import { FormControl, FormHelperText, FormLabel, Typography } from '@mui/material';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { DatePicker, dateTimePickerTabsClasses, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as React from 'react';
import "./datepicker.css";
import moment from 'moment';
import Helpers from '../../helpers/helpers';


export default function CustomizedDatePicker({ values, setFormValues, error, required, title, name, handlecheck, check, disabled, InputProps, readOnly, format, rerenderKey = 'key', maxDate }) {
    const outerTheme = createTheme({

    });
    const handleDateChange = (e) => {
        const date = e;
        const momentDate = moment(date, 'ddd MMM DD YYYY hh:mm:ss [GMT]ZZ (zz)');
        const isoString = momentDate.format('YYYY-MM-DD');
        if (Helpers.isNullOrEmpty(name)) {
            setFormValues(isoString)
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: isoString
            }))
        }

    }
    return (
        <>
            <FormControl variant="outlined" fullWidth>
                <FormLabel style={{ fontFamily: 'Manrope-Semibold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
                <ThemeProvider theme={outerTheme}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            // error={true}
                            key={rerenderKey}
                            value={values || null}
                            hiddenLabel={true}
                            disabled={disabled}
                            InputProps={InputProps}
                            maxDate={maxDate}
                            format={format ? format : 'dd/MM/yyyy'}
                            // onChange={(e) => check ? handlecheck(e) : setFormValues((prevValues) => ({
                            //     ...prevValues,
                            //     [name]: moment(e, 'YYYY-MM-DD hh:mm:ss').toDate()
                            // }))}
                            slots={{
                                openPickerIcon: () =>
                                    <div style={{ borderLeft: '1px solid #D9D9D9', paddingLeft: '10px' }}>
                                        <i className="ri-calendar-line"></i>
                                    </div>
                            }}
                            renderInput={(params) => (
                                <TextField {...params} value={values} />
                            )}
                            onChange={(e) => handleDateChange(e)}
                            sx={{
                                '& .MuiInputBase-input': {
                                    color: "#101010",
                                    height: "9px",
                                },
                                "& .MuiFormLabel-root": {
                                    fontSize: "1rem",
                                    top: "-7px",
                                },
                                "& .Mui-selected.Mui-disabled": {
                                    color: "rgba(0, 0, 0)", // (default alpha is 0.38)，
                                },
                                backgroundColor: disabled ? 'rgb(241, 243, 244)' : 'white'
                            }}
                            control={(params) => <TextField size="small" InputProps={InputProps} {...params} />}
                        />
                    </LocalizationProvider></ThemeProvider>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}
        </>


    );
}
